import React, {Component} from "react";
import League from "./League";
import LiveEvent from "./LiveEvent";
import lodash from "lodash";

class Leagues extends Component {

	render() {
		const {leagues, events, checkLeague, checkEvent, results, selected} = this.props;

		const sortedEvents = lodash.sortBy(events, i => i.time);

		return leagues.map((league) => {
			const all_events = sortedEvents
				.filter((event) => {return (event.league_id === league.id)})
				.map((event) => {
					const result = results.filter((result) => {return result.event === event.id}).map((result) => {return result});
					return <LiveEvent key={`live-event-${event.id}`} event={event} results={result} isChecked={event.id in selected} checkHandler={checkEvent}/>;
				});

			return (
				<League key={`live-league-${league.id}`} league={league} checkHandler={checkLeague}>
					{all_events}
				</League>
			);
		});
	}
}

export default Leagues;


// WEBPACK FOOTER //
// ./src/app/pages/Live/modules/Leagues.js